import { useState } from 'react'
import { useSelector } from 'react-redux'

import { getLoginFormStrings } from 'store/strings/selectors'
import {
  Header,
  Navigation,
} from 'ui-component-library/components/OrderConfirmation/LoginOrCreateAccount'
import LoginForm from './LoginForm'
import CreateAccountForm from './CreateAccountForm'

const STATES = {
  LOGIN: 'login' as const,
  CREATE_ACCOUNT: 'create-account' as const,
}

type Props = {
  titleText: string
  bodyText: string
}

function LoginOrCreateAccountContainer({ titleText, bodyText }: Props) {
  const [state, setState] = useState<typeof STATES[keyof typeof STATES]>(
    STATES.CREATE_ACCOUNT,
  )
  const { createAccountText, titleText: loginText } = useSelector(
    getLoginFormStrings,
  )

  function handleToggleState() {
    setState((s) =>
      s === STATES.CREATE_ACCOUNT ? STATES.LOGIN : STATES.CREATE_ACCOUNT,
    )
  }

  return (
    <>
      <Header titleText={titleText} bodyText={bodyText} />
      <Navigation
        loginText={loginText}
        createAccountText={createAccountText}
        activeState={state}
        onClick={handleToggleState}
      />
      {state === STATES.LOGIN && <LoginForm />}
      {state === STATES.CREATE_ACCOUNT && <CreateAccountForm />}
    </>
  )
}

export default LoginOrCreateAccountContainer
